import React from "react";
import { Component } from "react";
import { Switch } from "react-router-dom";
import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
import { getBoundingClientRect } from "../../utils/functions";
import { checkTranslation, translate } from "../../utils/useful";
import LoaderButton from "../LoaderButton";
import CardBuilder from "./CardBuilder";
import { FormBuilderObjects } from "../../variables/formBuilderData";
import HttpServices from "../../utils/Http.services";
import ButtonAnimated from "../buttons/ButtonAnimated";
import importedIcons from "./icons";
// import React, { useRef, useState } from "react";

class CustomizeCard extends Component {
  state = {
    // fields: [
    //   { id: "ali", item: "Priority", src: "/assets/icons/priority.svg" },
    //   { id: "ali1", item: "Flagged", src: "/assets/icons/flagged.svg" },
    //   { id: "ali2", item: "Assignee", src: "/assets/icons/assignee.svg" },
    //   { id: "ali3", item: "Start date", src: "/assets/icons/calendar.svg" },
    //   { id: "ali4", item: "Date", src: "/assets/icons/calendar.svg" },
    // ],
    // fullData:null,
    characters: [],
    visibleFields: [],
    visibleKeys: [],
    search: "",
  };

  componentDidMount() {

    let visibleKeys = this.props.view?.settings?.visibleKeys ?? []
    // let visibleFields = []

    // if (Array.isArray(this.props.headers)) {

    //   visibleKeys.forEach(fieldKey => {
    //     this.props.headers.forEach(header => {
    //       if (fieldKey == header.key) {
    //         visibleFields.push(header)
    //       }
    //     })
    //   })
    // }

    this.setState({ characters: this.props.headers, visibleKeys }, () => {
      this.generateVisibleFields()
    });
    // console.log(this.state.characters);
  }

  submitCardInfo = () => {


    console.log(this.props)
    let data = { frame: this.props.currentFrame._id, view: this.props.view?.id, }
    let cardInfo = this.cardBuilder.getInfo()
    data.settings = {}
    data.settings['cardInfo'] = cardInfo
    data.settings['visibleKeys'] = this.state.visibleKeys


    // console.log(data)

    // return


    this.setState({ isLoadingPost: true })
    HttpServices.request('addViewSettings', data, (fetchResult, fetchError) => {

      this.setState({ isLoadingPost: false })

      if (fetchError) {
        this.props.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
      }

      this.props.setViewSettings({ cardInfo, visibleKeys: this.state.visibleKeys })

      // if (this.props.changeValue) {
      //   this.props.changeValue(item)
      // }

      this.props.closeSide('customizeCardSide')

    })

  }

  generateVisibleFields = () => {

    let visibleKeys = this.state.visibleKeys
    let visibleFields = []

    if (Array.isArray(this.props.headers)) {

      visibleKeys.forEach(fieldKey => {
        this.props.headers.forEach(header => {
          if (fieldKey == header.key) {
            visibleFields.push(header)
          }
        })
      })
    }

    console.log(visibleFields)
    this.setState({ visibleFields: null }, () => {
      this.setState({ visibleFields })
    })
  }

  onDragEnd = (result) => {
    // console.log("hello", result);
    let items = Array.from(this.state.characters);
    let [reorderItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderItem);
    // return (items);
    this.setState({ characters: items }, () => {
      //   console.log("TP!", this.state.characters);
    });
  };

  searchInput = (e) => {
    this.setState({ search: e.target.value }, () => {
      this.filterHandler();
    });
  };


  filterHandler = () => {
    let fields = [...this.props.headers];
    let temp = [];
    for (let i = 0; i < fields.length; i++) {
      let content = fields[i];
      if (content.information.label.toLowerCase().includes(this.state.search.toLowerCase())) {
        temp.push(content);
      }
    }
    // console.log(temp);
    this.setState({ characters: temp });
  };


  makeVisible = (item) => {
    let visibleKeys = this.state.visibleKeys
    visibleKeys.push(item.key)
    this.setState({ visibleKeys }, () => {
      this.generateVisibleFields()
    })
  }

  makeInvisible = (key, index) => {
    let visibleKeys = this.state.visibleKeys
    visibleKeys.splice(index, 1)
    this.setState({ visibleKeys }, () => {
      this.generateVisibleFields()
    })
  }

  onSortChange = (visibleKeys) => {
    this.setState({ visibleKeys }, () => {
      this.generateVisibleFields()
    })
  }


  liveChangeValue = (key, content, extra) => {
    console.log("liveChangeValue")
    console.log(content)
  }


  render() {

    // console.log(this.props.view?.settings?.cardInfo)
    return (
      <div ref={el => this.scrollContainer = el} className="w-100 h-100  " style={{ overflow: 'auto' }}>
        {/* <div className="flexcb px-2 py-1" style={{ position: 'sticky', top: 0, zIndex: 1, boxShadow: '0px 0px 30px #10101010', borderBottom: '1px solid #f6f6f6', background: this.props.background ?? 'linear-gradient(to right, #fff , #fff)', backgroundColor: '#fff' }}>
          <p className="text-bold py-1 px-2">{translate('Customize Card')}</p>
        </div> */}

        <div className='flexcb  position-sticky top-0 w-100' style={{ padding: '12px 14px', background: 'linear-gradient(90deg, #fff, #fff)', zIndex: 2, borderBottom: '1px solid #eee' }}>
          <div className='flexc'>
            {/* {this.state.backbtn == true &&
              <button onClick={this.BackStage}>
                <img width={18} className='mrd-2 flexcc invert' src='/assets/icons/arrow-left-white.svg' />
              </button>
            } */}
            <p className=' font-size-14 text-semibold'>{translate('Customize Card')}</p>
          </div>
          <div className="flexc">
            <ButtonAnimated
              iconwidth='24px'
              onClick={this.state.isLoadingPost ? () => { } : () => { this.submitCardInfo() }}
              title={translate('Submit')}
              icon='/assets/icons/plus-white.svg'
              textColor={this.props.colors?.textColor ?? '#fff'}
              isLoading={this.state.isLoadingPost}
              bg={this.props.background ?? ' linear-gradient(90deg, #5856D6, #7D7AFF)'}
              width={'100%'}
            />
          </div>
          {/* <LoaderButton
            onClick={this.submitCardInfo}
            isLoading={this.state.isLoadingPost}
            text={translate('Submit')}
            // type={"Oval"}
            className={"text-bold text-small text-center flexcc w-100 br-20 py-1  "}
            background={this.props.colors?.background}
            width={20}
            height={20}
            color={this.props.colors?.textColor}
          /> */}


        </div>




        <div className="pt-3 pb-4" style={{ backgroundColor: '#f4f4f4' }}>
          <div className="px-4  mb-2">
            <p className="text-semibold ">Preview</p>
          </div>

          <CardBuilder
            data={this.props.view?.settings?.cardInfo}
            ref={el => this.cardBuilder = el}
            headers={this.props.headers}
            functionsHandler={this.props.functionsHandler}
            view={this.props.view}
            visibleKeys={this.state.visibleKeys}
            visibleFields={this.state.visibleFields}
            onSortChange={this.onSortChange}
            makeInvisible={this.makeInvisible}
            changeValue={this.liveChangeValue}
          />

          {this.state.visibleKeys?.length > 0 && (
            <div className="mt-2 px-4">
              <p className="text-smaller color-gray-2 px-1">{translate("Click on any of the fields on top to edit the configuration and style.")}</p>
            </div>
          )}


        </div>





        <div className="px-2">
          {/* <div className="w-100 mt-2" style={{}}>
            <div className="flexcb p-2" style={{ fontSize: "10px" }}>


              <div className="text-small text-semibold" style={{}}>
                <p>{translate('Cover field')}</p>
              </div>





              <div className="flexcc" >
                <div className="flexc">
                  <p>Crop</p>
                </div>
                <div className="flexc">
                  <label class="switch m-1">
                    <input type="checkbox" />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div className="flexc">
                  <p>Fit</p>
                </div>
              </div>
            </div>



            {this.state.characters.map((item, index) => {
              if (item.type == 'VideoInput' || item.type == 'ImageInput')
                return (
                  <div className="fields-box w-100">
                    <div className="fields flexcb p-2 w-100" style={{ transform: "none" }} >
                      <div className="flexc">


                        <label className=" d-flex" style={{ paddingBottom: 5 }} onClick={() => this.radioHandler(item.key)}>
                          <input className='mrd-2' type="radio" checked={this.state.selected == item.key} />
                          <p className="text-smaller" key={index}>{checkTranslation(item?.information?.label)} </p>
                        </label>

                      </div>

                    </div>
                  </div>

                )
            })}


            <div className=""></div>
          </div> */}


          <div className="text-small text-semibold px-2  pt-3" style={{ borderTop: '0px solid #eee' }}>
            <p>{translate('Invisible Fields')}</p>
          </div>

          <div className="px-2 mt-2 d-flex">
            <div className="fields-search flexc p-1 flex-1 br-20 mt-1" style={{ backgroundColor: '#f6f6f6' }}>
              <img src="/assets/icons/gantt/search.svg" className="mld-1" height={12} />
              <input value={this.state.search} onChange={(e) => this.searchInput(e)} type="text" name="name" className="fields-search text-smaller p-1" style={{ backgroundColor: 'transparent', borderBottom: "none", width: "100%" }} placeholder={translate("Find a field")} />
            </div>
          </div>


          <div style={{ position: "fixed", top: "0", left: "0" }} ref={(el) => (this.setPositionDiv = el)}></div>

          <div className="flexc scroll-no-scrollbar aa pb-5" style={{ flexDirection: "column", alignItems: "flex-start", backgroundColor: "#fff" }}>
            {this.state.visibleFields && (

              <DragDropContext onDragEnd={(result) => this.onDragEnd(result)}>
                <Droppable droppableId="droppable">
                  {(provided) => (
                    <div className="w-100" style={{ transform: "none" }} {...provided.droppableProps} ref={provided.innerRef}>
                      {Array.isArray(this.state.characters) &&
                        this.state.characters.map((item, index) => {

                          if (this.state.visibleKeys && !this.state.visibleKeys.includes(item.key)) {
                            // console.log(item)
                            return (

                              <Draggable key={item.key} draggableId={item.key} index={index}>
                                {(provided, snapshot) => {

                                  if (snapshot.isDragging) {
                                    if (!provided.draggableProps) {
                                      provided.draggableProps = { style: { boxShadow: "0px 0px 30px #10101090", zIndex: "10" } };
                                    }
                                    let bound = getBoundingClientRect(this.setPositionDiv);
                                    // console.log("HERE")

                                    // let scrollTop = this.scrollContainer.scrollTop
                                    // console.log(scrollTop)

                                    const offset = { x: bound.left, y: bound.top };
                                    let x = (provided.draggableProps?.style?.left ?? 0) - offset.x;
                                    let y = (provided.draggableProps?.style?.top ?? 0) - offset.y;
                                    // console.log(y)

                                    // y = y - scrollTop
                                    // console.log(y)
                                    provided.draggableProps.style.left = x + 'px';
                                    provided.draggableProps.style.top = y + 'px';
                                    provided.draggableProps.style.boxShadow = "0px 0px 10px #10101020";
                                    provided.draggableProps.style.zIndex = "10";

                                  }

                                  let fieldRef = FormBuilderObjects[item.type]


                                  return (
                                    <div className="fields-box w-100" style={{ borderBottom: '1px solid #eee' }}>
                                      <div className="fields flexcb p-2" style={{ transform: "none" }} ref={provided.innerRef} {...provided.draggableProps}>
                                        <div className="flexc">
                                          {/* <label class="switch">
                                        <input type="checkbox" />
                                        <span class="slider round"></span>
                                      </label> */}
                                          <img width={30} className='p-1' src={fieldRef?.icon} />
                                          <div>
                                            <p className="text-small mx-2">{checkTranslation(item?.information?.label)}</p>
                                            <p className="text-smallest mx-2 ">{checkTranslation(fieldRef?.label)} Field</p>
                                          </div>
                                        </div>

                                        <div className="flexc">

                                          <div style={{}} className="mx-1 cursor-poiner flexc" onClick={() => this.makeVisible(item)}>
                                            {/* <div className="flexcc" style={{height:14,width:14,borderRadius:20,background:'#007aff',color:'#fff'}}>+</div> */}
                                            <img height={14} className="mrd-1" src={importedIcons.eye} />
                                            <p className="text-smaller no-wrap" style={{ color: this.props.colors?.primaryColor ?? 'rgb(86,84,214)' }}>{translate('Make Visible')}</p>
                                          </div>

                                          {/* <div style={{ width: "15px" }} className="mx-1 cursor-poiner">
                                        <img className="" style={{ opacity: 0.8 }} src="/assets/icons/useful/settings.png" width="13px" />
                                      </div> */}


                                          <div style={{ width: "15px", display: 'none' }} {...provided.dragHandleProps}>
                                            <img className="" style={{ opacity: 0.8 }} src="/assets/icons/drag-and-drop.svg" width="13px" />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }}
                              </Draggable>
                            );
                          }
                        })}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            )}
          </div>
          {/* <div className="fields-buttons flexcb p-2 pt-1 w-100" style={{}}>
            <button className="fields-button text-smaller w-100 mrd-1" onClick={() => this.hideAllHandler()}>
              Hide all
            </button>
            <button className="fields-button text-smaller w-100 mld-1" onClick={() => this.showAllHandler()}>
              Show all
            </button>
          </div> */}
        </div>
      </div>
    );
  }
}

export default CustomizeCard;
